<template>
  <div class="container">
    <down2 @downclickhandler2="downClickHandler2" />
    <img class="backimg" src="../../public/image/index_about.jpg" alt />
    <div class="text">
      <p id='en1' class="en wow fadeInLeft" style="animation-duration: 2s;">ABOUT US</p>
      <p class="title wow fadeInLeft" style="animation-duration: 2s;" v-show="isShow">
        关于我们
      </p>
      <p class="con wow fadeInLeft" style="animation-duration: 2s;" >
        {{$t("home").about.text0}}
      </p>
      <p class="con wow fadeInLeft" style="animation-duration: 2s;" >
        {{$t("home").about.text1}}
      </p>
      <div class="btn wow fadeInLeft" style="animation-duration: 2s;">
        <span @click="gotoAbout">{{$t("btn")}}</span>
        <div class="arrow">
          <i class="iconfont icon-jiantou"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import down2 from "@/components/down2";
export default {
  data() {
    return {
      lan: "",
      isShow: true,
    };
  },
  mounted(){
    this.getLan();
    this.getShow();
  },
  methods: {
    downClickHandler2() {
      this.$emit("downclickhandler2");
    },
    gotoAbout() {
      window.open("./about.html", "_self");
    },
    getLan() {
      this.lan = localStorage.getItem("language");
    },
    getShow() {
      if(this.lan=='zh-CN'){
        this.isShow = true;
      }else{
        this.isShow = false;
        $('#en1').addClass('title');
      }
    }
  },
  components: {
    down2,
  },
};
</script>

<style lang="scss" scoped>
.lang-en .con {
  line-height: 1.5 !important;
}
.container {
  width: 100%;
  position: relative;
  .backimg {
    width: 100%;
    display: block;
    object-fit: contain;
  }
  .text {
    width: 30%;
    position: absolute;
    left: 10%;
    top: 50%;
    transform: translateY(-50%);
    .en {
      font-family: "SOURCEHANSANSCN-NORMAL";
      font-size: 40px;
      // opacity: 0.5;
      color: rgba(255, 255, 255, 0.5);
    }
    .title {
      font-family: "SOURCEHANSANSCN-BOLD";
      font-size: 36px;
      color: white;
      position: relative;
      padding-bottom: 30px;
      margin-bottom: 75px;
      &::after {
        display: inline-block;
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 60px;
        height: 1px;
        background-color: white;
      }
    }
    .con {
      font-size: 16px;
      font-family: "SOURCEHANSANSCN-LIGHT";
      color: white;
      line-height: 30px;
      
    }
    .btn {
      border: 1px solid white;
      padding: 20px 35px;
      position: relative;
      display: flex;
      align-items: center;
      width: 152px;
      margin-top: 120px;
      cursor: pointer;
      span {
        color: white;
        white-space: nowrap;
        font-family: "SOURCEHANSANSCN-NORMAL";
        font-size: 14px;
      }
      &:hover {
        .arrow {
          transform: translateX(20px);
        }
      }
      .arrow {
        transition: all 600ms;
        i {
          color: white;
          font-size: 16px;
          position: relative;
          margin-left: 80px;
          &::after {
            display: inline-block;
            content: "";
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: -55px;
            width: 64px;
            height: 1px;
            background-color: white;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1600px) {
  .container {
    .text {
      .btn {
        margin-top: 80px;
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .container {
    .backimg {
      height: 400px;
      object-fit: cover;
    }
    .text {
      width: 90%;
      left: 5%;
      .en {
        font-size: 20px;
      }
      .title {
        font-size: 18px;
        padding-bottom: 10px;
      }
      .con {
        margin-top: 30px;
      }
      .btn {
        margin-top: 30px;
        width: 152px;
        padding: 10px 10px;
      }
    }
  }
}
</style>
